/** The thin bar the layout shows while a child loader is running. */
export default function RouteProgress() {
  return <span className="route-progress" aria-hidden="true" />;
}
